module.exports = __webpack_public_path__ + "static/media/getting-started-rocket.b520569e.png";